import { render, staticRenderFns } from "./StatistiqueGeneral.vue?vue&type=template&id=24aad789&"
import script from "./StatistiqueGeneral.vue?vue&type=script&lang=js&"
export * from "./StatistiqueGeneral.vue?vue&type=script&lang=js&"
import style0 from "./StatistiqueGeneral.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports